// extracted by mini-css-extract-plugin
export default {"container":"lD-z","dimension":"mD-z","dimensionLabels":"nD-z"};